<template>
    <div>
        <PagesDetail :lng="lng"></PagesDetail>
    </div>
</template>

<script setup lang="ts">
import langObj from "@/utils/lang";
var lng: any = langObj['zh']
useSeoMeta({
    title: '默认标题-力士达集团|LISHIDA GROUP',
    description: '默认概要|力士达集团|LISHIDA GROUP',
    keywords: '默认关键词,力士达,lsd,力士达集团,LISHIDA GROUP',
});

useHead({
    script: [
        { src: '/static/js/jquery.min.js' },
        { src: '/static/js/jquery.imagezoom.min.js' },
        { src: '/static/js/swiper-bundle/swiper-bundle.min.js' }
    ],
    link:[
        { rel: 'stylesheet', href: '/static/js/swiper-bundle/swiper-bundle.min.css' }
    ]
})
</script>